import React, { useEffect, useState } from "react";
import "./EditCampaign.css";
import { useDispatch, useSelector } from "react-redux";
import { createCampaignData } from "../../features/createCampaign/createCampaignSlice";
import { Check, Clear } from "@mui/icons-material";
import Multiselect from "multiselect-react-dropdown";
import { availibilityCheckData } from "../../features/availibilityCheck/availibilityCheckSlice";
import { editCampaignData } from "../../features/editCampaign/editCampaignSlice";

const EditCampaign = () => {
  const dispatch = useDispatch();
  const availibilityCheck = useSelector(
    (state) => state.availibilityCheck.data
  );
  const availibilityCheckpending = useSelector(
    (state) => state.availibilityCheck.pending
  );
  const availibilityCheckerror = useSelector(
    (state) => state.availibilityCheck.error
  );

  const getCampaignByIdData = useSelector(
    (state) => state.getCampaignById.data
  );
  const getCampaignByIdpending = useSelector(
    (state) => state.getCampaignById.pending
  );
  const getCampaignByIderror = useSelector(
    (state) => state.getCampaignById.error
  );

  // console.log(getCampaignByIdData)

  const [campaignData, setCampaignData] = useState({
    id: "",
    title: "",
    companyName: "",
    selectedAdTypes: [],
    updatedItems: [],
    ads: [
      {
        bannerAds: {
          ad_category: "",
          target_url: "",
          startDate: "",
          endDate: "",
        },
      },

      {
        footerAds: {
          ad_category: "",
          target_url: "",
          startDate: "",
          endDate: "",
        },
      },

      {
        interstitialAds: {
          ad_category: "",
          target_url: "",
          startDate: "",
          endDate: "",
        },
      },
    ],
  });

  useEffect(() => {
    // Compare and update local state based on Redux state
    setCampaignData((prevLocalState) => {
      const updatedLocalState = deepCopy(prevLocalState);
      updateNestedProperties(updatedLocalState, getCampaignByIdData);
      return updatedLocalState;
    });
  }, [getCampaignByIdData]);

  // Recursively update nested properties
  const updateNestedProperties = (localObj, reduxObj) => {
    for (const key in reduxObj) {
      if (reduxObj.hasOwnProperty(key)) {
        if (
          key === "ads" &&
          Array.isArray(localObj[key]) &&
          Array.isArray(reduxObj[key])
        ) {
          // Ensure 'ads' property exists and is an array
          localObj[key] = updateAdsArray(localObj[key], reduxObj[key]);
        } else if (
          key === "selectedAdTypes" &&
          Array.isArray(localObj[key]) &&
          Array.isArray(reduxObj[key])
        ) {
          // Ensure 'selectedAdType' property exists and is an array
          localObj[key] = reduxObj[key];
        } else if (
          typeof reduxObj[key] === "object" &&
          reduxObj[key] !== null
        ) {
          // If the property is an object, recursively update its properties
          localObj[key] = localObj[key] || {};
          updateNestedProperties(localObj[key], reduxObj[key]);
        } else if (key in localObj) {
          // Update the property if it exists in both local and redux states
          localObj[key] = reduxObj[key];
        }
      }
    }
  };

  // Update the 'ads' array
  const updateAdsArray = (localArray, reduxArray) => {
    return reduxArray.map((reduxItem, index) => {
      return {
        ...localArray[index], // Keep existing properties
        ...reduxItem, // Update with Redux state properties
      };
    });
  };

  // Deep copy function to create a new copy of objects and arrays
  const deepCopy = (obj) => JSON.parse(JSON.stringify(obj));

  const [bannerAdsStartDate, setbannerAdsStartDate] = useState("");
  const [bannerAdsEndDate, setbannerAdsEndDate] = useState("");
  const [footerAdsEndDate, setfooterAdsEndDate] = useState("");
  const [footerAdsStartDate, setfooterAdsStartDate] = useState("");
  const [interstitialAdsStartDate, setinterstitialAdsStartDate] = useState("");
  const [interstitialAdsEndDate, setinterstitialAdsEndDate] = useState("");
  const [bannerDatesResponse, setbannerDatesResponse] = useState("");
  const [interstitialDatesResponse, setinterstitialDatesResponse] =
    useState("");
  const [footerDatesResponse, setfooterDatesResponse] = useState("");

  const adTypesOptions = [
    { id: 0, value: "bannerAds", label: "BannerAds" },
    { id: 1, value: "footerAds", label: "FooterAds" },
    { id: 2, value: "interstitialAds", label: "InterstitialAds" },

    // Add more ad types as needed
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log(value);
    setCampaignData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("efrkjdf");

    const formData = new FormData();
    formData.append("id", getCampaignByIdData._id);
    formData.append("title", campaignData.title);
    formData.append("companyName", campaignData.companyName);
    formData.append("ads", JSON.stringify(campaignData.ads));
    formData.append(
      "selectedAdTypes",
      JSON.stringify(campaignData.selectedAdTypes)
    );
    formData.append("updatedItems", JSON.stringify(campaignData.updatedItems));
    formData.append(
      "bannerAds",
      campaignData?.ads[0]?.bannerAds?.bannerAds_image
    );
    formData.append(
      "footerAds",
      campaignData?.ads[0]?.footerAds?.footerAds_image
    );
    formData.append(
      "interstitialAds",
      campaignData?.ads[0]?.interstitialAds?.interstitialAds_image
    );

    for (let pair of formData.entries()) {
      console.log(pair);
    }

    dispatch(editCampaignData(formData))
      .then((result) => {
        // if(result?.payload?.response?.status=== 404){
        //   alert(result?.payload?.response?.data?.msg);
        // }else if(result?.payload?.status=== true){
        //   window.location.href ='https://api.cricway.live/admin/all-campaign'
        //   alert(result?.payload?.msg)
        // }

        console.log("Form submitted successfully!", result);
        //  window.location.reload()
        // Handle the result as needed
      })
      .catch((error) => {
        console.error("Form submission failed:", error.message);
        // Handle the error as needed
      });
  };

  const handleSelect = async (selectedList) => {
    const newItem = await selectedList.filter(
      (selectedItem) =>
        !campaignData.selectedAdTypes.some(
          (oldItem) => oldItem.id === selectedItem.id
        )
    );
    // const xyz = newItem[0].value
    //   if(!campaignData.updatedItems.includes(newItem[0].value)){
    //   setCampaignData((prevData)=>({
    //     ...prevData,
    //     updatedItems: [...prevData.updatedItems, newItem[0].value],
    //     ads: [
    //       {
    //         ...prevData.ads[0],
    //        [ newItem[0].value]: {
    //           ...prevData.ads[0][newItem[0].value],
    //           isNew: true,

    //         },
    //       },
    //     ],
    //   }))
    // }
    setCampaignData((prevData) => ({
      ...prevData,
      selectedAdTypes: selectedList,
    }));

    for (let i = 0; i < selectedList.length; i++) {
      console.log(selectedList[i].value);
      switch (selectedList[i].value) {
        case "bannerAds":
          setCampaignData((prevFormData) => ({
            ...prevFormData,
            ads: [
              {
                ...prevFormData.ads[0],
                bannerAds: {
                  ...prevFormData.ads[0].bannerAds,
                  ad_category: selectedList[i].label,
                },
              },
            ],
          }));
          // setCampaignData((campaignData) =>({...campaignData, bannerAds:{...campaignData.bannerAds, ad_category: selectedList[i].label }}))
          break;
        case "footerAds":
          setCampaignData((prevFormData) => ({
            ...prevFormData,
            ads: [
              {
                ...prevFormData.ads[0],
                footerAds: {
                  ...prevFormData.ads[0].footerAds,
                  ad_category: selectedList[i].label,
                },
              },
            ],
          }));
          // setCampaignData((campaignData) =>({...campaignData, footerAds:{...campaignData.footerAds, ad_category: selectedList[i].label }}))
          break;
        case "interstitialAds":
          setCampaignData((prevFormData) => ({
            ...prevFormData,
            ads: [
              {
                ...prevFormData.ads[0],
                interstitialAds: {
                  ...prevFormData.ads[0].interstitialAds,
                  ad_category: selectedList[i].label,
                },
              },
            ],
          }));
          // setCampaignData((campaignData) =>({...campaignData, interstitialAds:{...campaignData.interstitialAds, ad_category: selectedList[i].label }}))
          break;
        default:
          return null;
      }
    }
  };

  const handleFileChange = (e) => {
    // console.log(e.target)
    const image = e.target.files[0];
    const id = e.target.id;

    switch (id) {
      case "bannerAds":
        setCampaignData((prevFormData) => ({
          ...prevFormData,
          ads: [
            {
              ...prevFormData.ads[0],
              bannerAds: {
                ...prevFormData.ads[0].bannerAds,
                bannerAds_image: image,
              },
            },
          ],
        }));

        if (!campaignData.updatedItems.includes("bannerAds")) {
          setCampaignData((prevData) => ({
            ...prevData,
            updatedItems: [...prevData.updatedItems, "bannerAds"],
          }));
        }
        // setCampaignData({...campaignData, "bannerAds_image" : image
        //  });
        break;

      case "footerAds":
        setCampaignData((prevFormData) => ({
          ...prevFormData,
          ads: [
            {
              ...prevFormData.ads[0],
              footerAds: {
                ...prevFormData.ads[0].footerAds,
                footerAds_image: image,
              },
            },
          ],
        }));
        if (!campaignData.updatedItems.includes("footerAds")) {
          setCampaignData((prevData) => ({
            ...prevData,
            updatedItems: [...prevData.updatedItems, "footerAds"],
          }));
        }
        // setCampaignData({...campaignData, "footerAds_image" : image
        //  });
        break;

      case "interstitialAds":
        setCampaignData((prevFormData) => ({
          ...prevFormData,
          ads: [
            {
              ...prevFormData.ads[0],
              interstitialAds: {
                ...prevFormData.ads[0].interstitialAds,
                interstitialAds_image: image,
              },
            },
          ],
        }));
        if (!campaignData.updatedItems.includes("interstitialAds")) {
          setCampaignData((prevData) => ({
            ...prevData,
            updatedItems: [...prevData.updatedItems, "interstitialAds"],
          }));
        }
        // setCampaignData({...campaignData, "interstitialAds_image" : image
        //  });
        break;

      default:
        return null;
    }
  };

  const createAdHandleChange = async (e, index) => {
    const { name, value, id } = e.target;

    switch (id) {
      case "bannerAds":
        setCampaignData((prevFormData) => ({
          ...prevFormData,
          ads: [
            {
              ...prevFormData.ads[0],
              bannerAds: {
                ...prevFormData.ads[0].bannerAds,
                [name]: value,
              },
            },
          ],
        }));
        if (!campaignData.updatedItems.includes("bannerAds")) {
          setCampaignData((prevData) => ({
            ...prevData,
            updatedItems: [...prevData.updatedItems, "bannerAds"],
          }));
        }

        if (name === "startDate") {
          setbannerAdsStartDate(value);
        } else if (name === "endDate") {
          setbannerAdsEndDate(value);
        }

        break;

      case "footerAds":
        setCampaignData((prevFormData) => ({
          ...prevFormData,
          ads: [
            {
              ...prevFormData.ads[0],
              footerAds: {
                ...prevFormData.ads[0].footerAds,
                [name]: value,
              },
            },
          ],
        }));
        if (!campaignData.updatedItems.includes("footerAds")) {
          setCampaignData((prevData) => ({
            ...prevData,
            updatedItems: [...prevData.updatedItems, "footerAds"],
          }));
        }
        if (name === "startDate") {
          setfooterAdsStartDate(value);
        } else if (name === "endDate") {
          setfooterAdsEndDate(value);
        }

        break;

      case "interstitialAds":
        setCampaignData((prevFormData) => ({
          ...prevFormData,
          ads: [
            {
              ...prevFormData.ads[0],
              interstitialAds: {
                ...prevFormData.ads[0].interstitialAds,
                [name]: value,
              },
            },
          ],
        }));
        if (!campaignData.updatedItems.includes("interstitialAds")) {
          setCampaignData((prevData) => ({
            ...prevData,
            updatedItems: [...prevData.updatedItems, "interstitialAds"],
          }));
        }

        if (name === "startDate") {
          setinterstitialAdsStartDate(value);
        } else if (name === "endDate") {
          setinterstitialAdsEndDate(value);
        }
        break;

      default:
        return null;
    }
  };

  const handleClearOnClick = (e, id) => {
    // console.log(id)
    const updatedSelectedAds = campaignData.selectedAdTypes.filter(
      (item) => item.id !== id
    );
    handleSelect(updatedSelectedAds);
    // console.log(updatedItems)
  };

  const generateInputFields = () => {
    const inputFields = [];
    for (let i = 0; i < campaignData.selectedAdTypes.length; i++) {
      inputFields.push(
        <div key={i} className="input-group">
          <div className="createAd">
            {/* <label >
                Ad Category:
                <input
                  type="text"
                  name="ad_category"
                  id = {`${campaignData.selectedAdType[i].value}`}
                  className="inputLabel"
                  required
                  value= { campaignData.ads[i][`${campaignData.selectedAdType[i].value}`].ad_category}
                  onChange={createAdHandleChange}
                />
              </label>
              <br /> */}

            <h4 className="adHeading">
              {campaignData.selectedAdTypes[i].label}
            </h4>
            <Clear
              className="clearForm"
              onClick={(e) =>
                handleClearOnClick(e, campaignData.selectedAdTypes[i].id)
              }
            />
            <br />
            <label className="startDate">
              Start Date:
              <input
                required
                type="date"
                name="startDate"
                id={`${campaignData.selectedAdTypes[i].value}`}
                value={
                  campaignData.ads[0][
                    `${campaignData.selectedAdTypes[i].value}`
                  ].startDate
                }
                onChange={(e) => createAdHandleChange(e, i)}
              />
            </label>
            <br />

            <label className="endDate">
              End Date:
              <input
                required
                type="date"
                name="endDate"
                id={`${campaignData.selectedAdTypes[i].value}`}
                value={
                  campaignData.ads[0][
                    `${campaignData.selectedAdTypes[i].value}`
                  ].endDate
                }
                onChange={(e) => createAdHandleChange(e, i)}
              />
            </label>
            <br />

            {/* <div className="availibilityStatus">
              
               {campaignData.selectedAdTypes[i].value === 'bannerAds' && (<div>{bannerDatesResponse === '' && (<div className="emptyStatus">checking slots availibility...</div>)}{bannerDatesResponse === "Dates are not Available" && (<div className="availibilityStatusfail"><Clear className="clear"/><p>These slots are not Available</p></div>)}{bannerDatesResponse === 'Dates are Available' && (<div className="availibilityStatusSuccess"><Check className="check"/><p>These slots are Available</p></div>)}</div>)} 
               {campaignData.selectedAdTypes[i].value === 'footerAds' && (<div>{footerDatesResponse === '' && (<div className="emptyStatus">checking slots availibility...</div>)}{footerDatesResponse === "Dates are not Available" && (<div className="availibilityStatusfail"><Clear className="clear"/><p>These slots are not Available</p></div>)}{footerDatesResponse === 'Dates are Available' && (<div className="availibilityStatusSuccess"><Check className="check"/><p>These slots are Available</p></div>)}</div>)} 
               {campaignData.selectedAdTypes[i].value === 'interstitialAds' && (<div>{interstitialDatesResponse === '' && (<div className="emptyStatus">checking slots availibility...</div>)}{interstitialDatesResponse === "Dates are not Available" && (<div className="availibilityStatusfail"><Clear className="clear"/><p>These slots are not Available</p></div>)}{interstitialDatesResponse === 'Dates are Available' && (<div className="availibilityStatusSuccess"><Check className="check"/><p>These slots are Available</p></div>)}</div>)} 
  
               
              </div> */}

            <label className="targetUrl">
              Target URL:
              <input
                type="text"
                name="target_url"
                id={`${campaignData.selectedAdTypes[i].value}`}
                required
                value={
                  campaignData.ads[0][
                    `${campaignData.selectedAdTypes[i].value}`
                  ].target_url
                }
                onChange={(e) => createAdHandleChange(e, i)}
                // disabled = {(campaignData.selectedAdTypes[i].value === 'bannerAds' && (bannerDatesResponse === '' || bannerDatesResponse === "Dates are not Available")) || (campaignData.selectedAdTypes[i].value === 'footerAds' && (footerDatesResponse === '' || footerDatesResponse === "Dates are not Available")) || (campaignData.selectedAdTypes[i].value === 'interstitialAds' && (interstitialDatesResponse === '' || interstitialDatesResponse === "Dates are not Available"))  }
              />
            </label>
            <br />

            <label className="fileUpload">
              Upload Files:
              <input
                type="file"
                name="files"
                // required =  {campaignData.ads[0][`${campaignData.selectedAdTypes[i].value}`].isNew === true}
                accept="image/png, image/jpeg, image/gif, image/tiff, image/psd,"
                id={`${campaignData.selectedAdTypes[i].value}`}
                // disabled = {(campaignData.selectedAdTypes[i].value === 'bannerAds' && (bannerDatesResponse === '' || bannerDatesResponse === "Dates are not Available")) || (campaignData.selectedAdTypes[i].value === 'footerAds' && (footerDatesResponse === '' || footerDatesResponse === "Dates are not Available")) || (campaignData.selectedAdTypes[i].value === 'interstitialAds' && (interstitialDatesResponse === '' || interstitialDatesResponse === "Dates are not Available"))  }
                onChange={handleFileChange}
              />
            </label>
            <div className="availibilityStatus">
              {/* {campaignData.selectedAdType[i].value === 'bannerAds' && (<div>{}<div/>)(<div>{bannerDatesResponse === '' && (<div className="emptyStatus"></div>)}{bannerDatesResponse === "Dates are not Available" && (<div className="availibilityStatusfail"><Clear className="clear"/><p>Slots are not Available</p></div>)}{bannerDatesResponse === 'Dates are Available' && (<div className="availibilityStatusSuccess"><Check className="check"/><p>Slots are Available</p></div>)}</div>)} */}
              {campaignData.selectedAdTypes[i].value === "bannerAds" && (
                <div>
                  {bannerDatesResponse === "dates are wrong" && (
                    <div className="emptyStatus">
                      <Clear className="clear" />
                      End Date Should be greater than Start date
                    </div>
                  )}
                  {bannerDatesResponse === "Dates are not Available" && (
                    <div className="availibilityStatusfail">
                      <Clear className="clear" />
                      <p>Slots are not Available</p>
                    </div>
                  )}
                  {bannerDatesResponse === "Dates are Available" && (
                    <div className="availibilityStatusSuccess">
                      <Check className="check" />
                      <p>Slots are Available</p>
                    </div>
                  )}
                </div>
              )}
              {campaignData.selectedAdTypes[i].value === "footerAds" && (
                <div>
                  {footerDatesResponse === "dates are wrong" && (
                    <div className="emptyStatus">
                      <Clear className="clear" />
                      End Date Should be greater than Start date
                    </div>
                  )}
                  {footerDatesResponse === "Dates are not Available" && (
                    <div className="availibilityStatusfail">
                      <Clear className="clear" />
                      <p>Slots are not Available</p>
                    </div>
                  )}
                  {footerDatesResponse === "Dates are Available" && (
                    <div className="availibilityStatusSuccess">
                      <Check className="check" />
                      <p>Slots are Available</p>
                    </div>
                  )}
                </div>
              )}
              {campaignData.selectedAdTypes[i].value === "interstitialAds" && (
                <div>
                  {interstitialDatesResponse === "dates are wrong" && (
                    <div className="emptyStatus">
                      <Clear className="clear" />
                      End Date Should be greater than Start date
                    </div>
                  )}
                  {interstitialDatesResponse === "Dates are not Available" && (
                    <div className="availibilityStatusfail">
                      <Clear className="clear" />
                      <p>Slots are not Available</p>
                    </div>
                  )}
                  {interstitialDatesResponse === "Dates are Available" && (
                    <div className="availibilityStatusSuccess">
                      <Check className="check" />
                      <p>Slots are Available</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          {/* 
            <input type="text" name={`ad${i}`} /> */}
        </div>
      );
    }
    return inputFields;
  };

  useEffect(() => {
    if (bannerAdsStartDate !== "" && bannerAdsEndDate !== "") {
      if (bannerAdsStartDate > bannerAdsEndDate) {
        setbannerDatesResponse("dates are wrong");
      } else {
        dispatch(
          availibilityCheckData({
            id: "BANNER",
            newAdStartDate: campaignData.ads[0].bannerAds.startDate,
            newAdEndDate: campaignData.ads[0].bannerAds.endDate,
          })
        )
          .then((result) => {
            console.log(result);
            setbannerDatesResponse(result.payload.msg);
            // Handle the result as needed
          })
          .catch((error) => {
            console.error("Form submission failed:", error.message);
            // Handle the error as needed
          });
      }
    }
  }, [bannerAdsStartDate, bannerAdsEndDate]);

  useEffect(() => {
    if (footerAdsStartDate !== "" && footerAdsEndDate !== "") {
      if (footerAdsStartDate > footerAdsEndDate) {
        setfooterDatesResponse("dates are wrong");
      } else {
        dispatch(
          availibilityCheckData({
            id: "FOOTER",
            newAdStartDate: campaignData.ads[0].footerAds.startDate,
            newAdEndDate: campaignData.ads[0].footerAds.endDate,
          })
        )
          .then((result) => {
            console.log(result);
            setfooterDatesResponse(result.payload.msg);
            // Handle the result as needed
          })
          .catch((error) => {
            console.error("Form submission failed:", error.message);
            // Handle the error as needed
          });
      }
    }
  }, [footerAdsStartDate, footerAdsEndDate]);

  useEffect(() => {
    if (interstitialAdsStartDate !== "" && interstitialAdsEndDate !== "") {
      if (interstitialAdsStartDate > interstitialAdsEndDate) {
        setinterstitialDatesResponse("dates are wrong");
      } else {
        dispatch(
          availibilityCheckData({
            id: "INTERSTITIAL",
            newAdStartDate: campaignData.ads[0].interstitialAds.startDate,
            newAdEndDate: campaignData.ads[0].interstitialAds.endDate,
          })
        )
          .then((result) => {
            setinterstitialDatesResponse(result.payload.msg);
          })
          .catch((error) => {
            console.error("Form submission failed:", error.message);
            // Handle the error as needed
          });
      }
    }
  }, [interstitialAdsStartDate, interstitialAdsEndDate]);

  // useEffect(()=>{
  //     if(bannerAdsStartDate !== "" && bannerAdsEndDate !== ""){
  //       dispatch(
  //         availibilityCheckData({
  //           id: 'bannerAds',
  //           newAdStartDate: campaignData.ads[0].bannerAds.startDate,
  //           newAdEndDate: campaignData.ads[0].bannerAds.endDate,
  //         })
  //       ).then((result) => {
  //         console.log(result)
  //         setbannerDatesResponse(result.payload.msg)
  //         // Handle the result as needed
  //       })
  //       .catch((error) => {

  //         console.error('Form submission failed:', error.message);
  //         // Handle the error as needed
  //       });
  //     }
  //     },[bannerAdsStartDate, bannerAdsEndDate])

  //     useEffect(()=>{
  //       if(footerAdsStartDate !== "" && footerAdsEndDate !== ""){
  //         dispatch(
  //           availibilityCheckData({
  //             id: "footerAds",
  //             newAdStartDate: campaignData.ads[0].footerAds.startDate,
  //             newAdEndDate: campaignData.ads[0].footerAds.endDate,
  //           })
  //         ).then((result) => {
  //           console.log(result)
  //           setfooterDatesResponse(result.payload.msg)
  //           // Handle the result as needed
  //         })
  //         .catch((error) => {

  //           console.error('Form submission failed:', error.message);
  //           // Handle the error as needed
  //         });
  //       }
  //       },[footerAdsStartDate, footerAdsEndDate])

  //       useEffect(()=>{
  //         if(interstitialAdsStartDate !== "" && interstitialAdsEndDate !== ""){
  //           dispatch(
  //             availibilityCheckData({
  //               id: "interstitialAds",
  //               newAdStartDate: campaignData.ads[0].interstitialAds.startDate,
  //               newAdEndDate: campaignData.ads[0].interstitialAds.endDate,
  //             })
  //           ).then((result) => {
  //             setinterstitialDatesResponse(result.payload.msg)
  //           })
  //           .catch((error) => {

  //             console.error('Form submission failed:', error.message);
  //             // Handle the error as needed
  //           });
  //         }
  //         },[interstitialAdsStartDate, interstitialAdsEndDate])

  return (
    <div className="createCampaign">
      <div className="createCampaignWrapper">
        <h2 className="formTitle">Edit Campaign Form</h2>
        <form
          className="campaignForm"
          onSubmit={handleSubmit}
          encType="multipart/form-data"
        >
          <label>
            Title:
            <input
              type="text"
              name="title"
              required
              value={campaignData.title}
              onChange={handleChange}
            />
          </label>
          <br />

          <label>
            Company Name:
            <input
              type="text"
              name="companyName"
              required
              value={campaignData.companyName}
              onChange={handleChange}
            />
          </label>
          <br />

          <label className="adSelectionInput">
            Select Ad Types:
            <Multiselect
              className="multiselect"
              options={adTypesOptions}
              selectedValues={campaignData.selectedAdTypes}
              onSelect={handleSelect}
              onRemove={handleSelect}
              displayValue="label"
              required
            />
          </label>
          <br />

          {/* <button className='createAdButton' onClick={()=>{handleCreateAd()}}>+ Create Ad</button> */}

          {/* <label>
      Upload Files:
      <input type="file" name="files" multiple onChange={handleFileChange} />
    </label>
    <br /> */}

          {/* <CreateAdForm /> */}
          <div id="inputFieldsContainer">{generateInputFields()}</div>

          <button type="submit" className="modifyCampaignButton">
            Modify Campaign
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditCampaign;
